export const TRANSLATIONS_EN_HOME_QUEUE_AND_ACTIVITY = {
  "home.actionItems.eyebrow": "Pending actions",
  "home.actionItems.title": "Recommended actions",
  "home.actionItems.connection": "Suggestions to keep the queue up to date.",
  "home.actionItems.empty": "No pending actions.",
  "home.actionItems.unknownDocument": "Unknown document",
  "home.actionItems.due": "Due",
  "home.smartQueue.eyebrow": "Priority items",
  "home.smartQueue.title": "Documents that need your review",
  "home.smartQueue.totalLabel": "pending",
  "home.smartQueue.description": "Ranked by risk, responsible owner, and each document's status.",
  "home.smartQueue.connection": "Fueled by the latest detected dates and classifications.",
  "home.smartQueue.metricsTitle": "Operational metrics (optional)",
  "home.smartQueue.previewTitle": "Highest priority",
  "home.smartQueue.previewSubtitle": "Top 5",
  "home.smartQueue.previewAction": "View",
  "home.smartQueue.previewFilterRole": "Filter by role",
  "home.smartQueue.previewViewAll": "View all",
  "home.smartQueue.status.needsReview": "Need your review",
  "home.smartQueue.status.processing": "Still processing",
  "home.smartQueue.status.ready": "Ready to publish",
  "home.smartQueue.statusHelper.needsReview": "Human approval required before publishing.",
  "home.smartQueue.statusHelper.processing": "AI is still extracting and classifying.",
  "home.smartQueue.statusHelper.ready": "Clear to move into publication or querying.",
  "home.smartQueue.cta": "View priority items",
  "home.smartQueue.tooltip": "Open the full list of prioritized documents.",
  "home.smartQueue.clearFilter": "Clear status filter",
  "home.smartQueue.panelEyebrow": "Prioritization detail",
  "home.smartQueue.panelTitle": "Documents grouped by the assistant",
  "home.smartQueue.panelSubtitle": "Broken down by automation status and triggering role.",
  "home.smartQueue.closePanel": "Close priority items panel",
  "home.smartQueue.badgeRole": "Triggered by role",
  "home.smartQueue.badgeDate": "Triggered by date",
  "home.smartQueue.filterActive": "Filter applied by role or status.",
  "home.smartQueue.actions.snooze": "Snooze 24h",
  "home.smartQueue.actions.done": "Mark done",
  "home.smartQueue.actions.assign": "Assign to me",
  "home.smartQueue.markAsDone": "Mark as Done",
  "home.smartQueue.snooze": "Snooze",
  "home.smartQueue.recommendedAction": "Recommended Action",
  "home.smartQueue.mutation.snoozeSuccess": "Item snoozed for 24h.",
  "home.smartQueue.mutation.doneSuccess": "Item marked as done.",
  "home.smartQueue.mutation.assignSuccess": "Item assigned to you.",
  "home.smartQueue.mutation.reclassifySuccess": "Document reclassified successfully.",
  "home.smartQueue.reclassifyTooltip": "Re-analyze with AI",
  "home.smartQueue.reclassifyModal.title": "Reclassify Document",
  "home.smartQueue.reclassifyModal.reasonLabel": "Reason (required)",
  "home.smartQueue.reclassifyModal.reasonPlaceholder": "Ex: Document incorrectly classified as contract",
  "home.smartQueue.reclassifyModal.correctedTypeLabel": "Correct classification type (required)",
  "home.smartQueue.reclassifyModal.correctedTypePlaceholder": "Select correct type...",
  "home.smartQueue.reclassifyModal.originalTypeHint": "Current type",
  "home.smartQueue.reclassifyModal.notesLabel": "Additional notes (optional)",
  "home.smartQueue.reclassifyModal.notesPlaceholder": "Additional information about reclassification...",
  "home.smartQueue.reclassifyModal.confirm": "Reclassify",
  "home.smartQueue.reclassifyModal.cancel": "Cancel",
  "home.smartQueue.reviewDocument": "Review Document",
  "home.smartQueue.openDocument": "Open document",
  "home.smartQueue.executeAction": "Execute action",
  "home.smartQueue.mutation.actionSuccess": "Action executed successfully.",
  "home.smartQueue.panelEmpty": "No pending documents.",
  "home.smartQueue.empty": "No pending items. You're up to date.",
  "home.nextAction.eyebrow": "Recommended next step",
  "home.nextAction.title": "Next action",
  "home.nextAction.connection": "Based on what was detected today.",
  "home.nextAction.reason.pending_review": "Some documents are waiting for your approval.",
  "home.nextAction.reason.new_documents": "New documents are ready to ingest.",
  "home.nextAction.reason.ready_to_query": "Everything is ready for you to query the assistant.",
  "home.nextAction.reason.due_soon": "A deadline is approaching.",
  "home.nextAction.reason.overdue": "A document is overdue.",
  "home.nextAction.reason.high_priority": "A high-priority document needs attention.",
  "home.nextAction.reason.compliance_required": "A compliance action is required.",
  "home.nextAction.tooltipLabel": "Why we suggest this",
  "home.nextAction.tooltip.queue": "Generated from detected dates, classifications, and your priority items.",
  "home.nextAction.ack": "Acknowledge",
  "home.nextAction.cta": "View",
  "home.nextAction.openDocument": "Open document",
  "home.nextAction.ackSuccess": "Action confirmed.",
  "home.nextAction.empty": "All clear. Nothing requires your attention right now.",
  "home.nextAction.action.review": "Review",
  "home.nextAction.action.upload": "Upload",
  "home.nextAction.action.chat": "Chat",
  "home.nextAction.reason.needs_review": "Documents need your approval.",
  "home.lastActivity.eyebrow": "Relevant activity",
  "home.lastActivity.title": "Recent decision changes",
  "home.lastActivity.connection": "We only surface changes that affect a decision or help explain it.",
  "home.lastActivity.previewTitle": "What changed",
  "home.lastActivity.previewSubtitle": "most recent",
  "home.lastActivity.previewAction": "Review",
  "home.lastActivity.markAllRead": "Mark all as read",
  "home.lastActivity.type.classification": "Classification",
  "home.lastActivity.type.ingestion": "Ingestion",
  "home.lastActivity.type.extraction": "Extraction",
  "home.lastActivity.type.normalization": "Normalization",
  "home.lastActivity.type.validation": "Validation",
  "home.lastActivity.tooltip": "Click to see how priorities changed.",
  "home.lastActivity.documentsImpacted": "Related documents",
  "home.lastActivity.queueImpacted": "Decision impact",
  "home.lastActivity.navigateQueue": "View impacted queue items",
  "home.lastActivity.historyLink": "See history",
  "home.lastActivity.historyEyebrow": "Relevant log",
  "home.lastActivity.historyTitle": "Activity history",
  "home.lastActivity.closeHistory": "Close history panel",
  "home.lastActivity.openPanel": "Open relevant activity",
  "home.lastActivity.closePanel": "Close relevant activity",
  "home.lastActivity.historyEmpty": "No events to display.",
  "home.lastActivity.empty": "No recent activity.",
  "home.lastActivity.supportSignal": "Support signal",
  "home.lastActivity.event.decisionUpdated": "Decision updated",
  "home.lastActivity.event.missingInformationDetected": "Missing information detected",
  "home.lastActivity.event.priorityRecalculated": "Priority recalculated",
  "home.lastActivity.event.evidenceAdded": "Evidence added",
  "home.lastActivity.event.stateChanged": "State changed",
  "home.lastActivity.event.actionExecuted": "Action executed",
  "home.lastActivity.event.supportSignal": "Support update",
  "home.lastActivity.event.decisionUpdatedCopy": "The decision changed recently and deserves a quick review.",
  "home.lastActivity.event.missingInformationDetectedCopy": "Missing data was detected and may block the next action.",
  "home.lastActivity.event.priorityRecalculatedCopy": "Priority changed and may require a faster review.",
  "home.lastActivity.event.evidenceAddedCopy": "New evidence arrived and the recommendation was re-evaluated.",
  "home.lastActivity.event.stateChangedCopy": "The decision changed state after a recent validation.",
  "home.lastActivity.event.actionExecutedCopy": "The action was registered and the decision should reflect a new state.",
  "home.lastActivity.event.supportSignalCopy": "A support signal was recorded without directly changing a visible decision.",
  "home.nextBestDecision.eyebrow": "Lead decision",
  "home.nextBestDecision.title": "Next best decision",
  "home.nextBestDecision.viewDecision": "View detail",
  "home.nextBestDecision.owner": "Owner",
  "home.nextBestDecision.dueAt": "Due",
  "home.nextBestDecision.nextAction": "Next action",
  "home.nextBestDecision.priority": "Priority",
  "home.nextBestDecision.priorityUnspecified": "No tier",
  "home.nextBestDecision.risk": "Risk",
  "home.nextBestDecision.notAvailable": "No data",
  "home.nextBestDecision.confidence": "Confidence",
  "home.nextBestDecision.functionalStatus": "Recommended action",
  "home.nextBestDecision.recommendationCopy": "Home IA highlights the best business recommendation for this case. Use the actions in the detail panel to assign, postpone, complete, discard, or reevaluate it.",
  "home.nextBestDecision.urgency.critical": "High urgency",
  "home.nextBestDecision.urgency.high": "Act soon",
  "home.nextBestDecision.urgency.medium": "Monitor closely",
  "home.nextBestDecision.urgency.low": "Low urgency",
  "home.nextBestDecision.allClear.title": "All caught up",
  "home.nextBestDecision.allClear.subtitle": "There are no decisions that need your attention right now. A good moment to review what's ahead.",
  "home.nextBestDecision.allClear.navLabel": "Quick access",
  "home.nextBestDecision.allClear.reviewExpirations": "Review expirations",
  "home.nextBestDecision.allClear.viewChanges": "View recent changes",
  "home.nextBestDecision.allClear.viewAlerts": "View alerts",
  "home.entityActions.toggle": "Entity actions",
  "home.entityActions.questionsTitle": "Suggested questions",
  "home.entityActions.questionsError": "Suggested questions could not be loaded.",
  "home.entityActions.questionsEmpty": "No suggested questions for this entity.",
  "home.entityActions.askAboutEntity": "Ask about this entity",
  "home.entityActions.askPrefill": "Tell me about",
  "home.entityActions.generate": "Generate document",
  "home.entityActions.sourcesTitle": "These sources will be used",
  "home.entityActions.sourcesError": "Sources could not be loaded.",
  "home.entityActions.sourcesEmpty": "No visible sources to generate from.",
  "home.entityActions.sourcesConfirm": "Generate with these sources",
  "home.entityActions.cancel": "Cancel",
  "home.entityActions.version": "version",
  "home.recentChanges.title": "Recent changes",
  "home.recentChanges.viewAll": "View all",
  "home.recentChanges.empty": "No recent relevant changes in your documents.",
  "home.recentChanges.errorTitle": "Couldn't load the changes",
  "home.recentChanges.errorMessage": "Try again in a few seconds.",
};
